import { ConfigProvider } from '@alicloudfe/components'

export const usePrefixCls = (
  tag?: string,
  props?: {
    prefix?: string
  }
) => {
  const getContext = ConfigProvider['getContext']
  const prefix = props?.prefix ?? getContext()?.prefix ?? 'next-'
  return `${prefix}${tag ?? ''}`
}
